import { render, staticRenderFns } from "./pwdlost-confirm.vue?vue&type=template&id=06aae7ce&scoped=true&"
import script from "./pwdlost-confirm.vue?vue&type=script&lang=ts&"
export * from "./pwdlost-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./main.css?vue&type=style&index=0&id=06aae7ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aae7ce",
  null
  
)

export default component.exports